import { handleActions } from "redux-actions";
import { WORKING_ORDER } from "constants/action-types";
import { initialBaseState, fetchActions, IFetchStoreState, updateActions } from "reducers/base-reducers";
import type { IWorkingOrder } from "types/cart";

export type IWorkingOrderState = IFetchStoreState<IWorkingOrder>;

export const order = handleActions<IWorkingOrderState>(
    {
        ...fetchActions(WORKING_ORDER.ORDER.FETCH),
        ...updateActions(WORKING_ORDER.ORDER),
    } as any,
    initialBaseState
);
